import { useCallback } from "react";

export function useScrollSyncCallbacks() {
  const handleBodyScroll = useCallback(
    (
      tableBodyRef: React.RefObject<HTMLDivElement | null>,
      tableHeaderScrollRef: React.RefObject<HTMLDivElement | null>
    ) => {
      if (tableBodyRef.current && tableHeaderScrollRef.current) {
        tableHeaderScrollRef.current.scrollLeft = tableBodyRef.current.scrollLeft;
      }
    },
    []
  );

  const handleHeaderScroll = useCallback(
    (
      tableBodyRef: React.RefObject<HTMLDivElement | null>,
      tableHeaderScrollRef: React.RefObject<HTMLDivElement | null>
    ) => {
      if (tableHeaderScrollRef.current && tableBodyRef.current) {
        tableBodyRef.current.scrollLeft = tableHeaderScrollRef.current.scrollLeft;
      }
    },
    []
  );

  return {
    handleBodyScroll,
    handleHeaderScroll,
  };
}
